import api from '@/services/api'
import type { ComboVariation, Proposta, PropostaItem } from '@/types'
import type { LayoutConfig } from '@/utils/dealCalculations'

export async function patchProposalStudioPresentation(
  proposal: Proposta,
  savedItems: PropostaItem[],
  savedLayout: LayoutConfig | undefined,
  savedComboVariations: ComboVariation[] | undefined,
): Promise<Proposta> {
  let existingDados: Record<string, unknown> = {}
  const rawDados = (proposal as Proposta & { dados?: string }).dados
  if (rawDados) {
    try {
      existingDados = JSON.parse(rawDados) as unknown as Record<string, unknown>
    } catch {
      existingDados = {}
    }
  }

  const sanitizedComboVariations = savedComboVariations?.filter((v) => v.itemIds?.length) ?? []
  const updatedDados = JSON.stringify({
    ...existingDados,
    comboVariations: sanitizedComboVariations,
    layout: savedLayout,
  })

  const { data: patchData } = await api.patch(`/propostas/${proposal.id}`, {
    items: savedItems,
    itens: savedItems,
    layout: savedLayout,
    dados: updatedDados,
    validade: proposal.validade,
    observacoes: proposal.observacoes,
    desconto: proposal.desconto,
    valor: proposal.valor,
    subtotal: proposal.subtotal,
    totalFinal: proposal.totalFinal,
  })

  return (patchData.data ?? patchData) as Proposta
}

export function parseComboVariationsFromDados(proposal: Proposta): ComboVariation[] {
  const ext = proposal as Proposta & { comboVariations?: ComboVariation[] }
  if (Array.isArray(ext.comboVariations) && ext.comboVariations.length > 0) {
    return ext.comboVariations
  }
  try {
    const dados = (proposal as Proposta & { dados?: string }).dados
    if (!dados) return []
    const parsed = JSON.parse(dados) as { comboVariations?: ComboVariation[] }
    return Array.isArray(parsed.comboVariations) ? parsed.comboVariations : []
  } catch {
    return []
  }
}
